
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Fade from '@mui/material/Fade';
import { switchMasterMode, switchApiUrl, switchApiPage, fetchApiData } from '../../../FlikTraxStore/Actions/apiActions';

const ArtistSearch = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const styles = theme => ({
        root: {
            width: "100%",
            marginTop: theme.spacing.unit * 3
        },
        table: {
            minWidth: 1020
        },
        tableWrapper: {
            overflowX: "auto"
        },
        hover: {
            "&:hover": {
                backgroundColor: 'rgb(7, 177, 77, 0.42)'
            }
        }
    });

    const encIOSURL = (str) => {
        return str.replace("”", '"').replace("“", '"').replace("’", "'").replace("‘", "'").replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[\u2013\u2014]/g, '-').replace(/[\u2026]/g, '...');
    }
    //const handleRequestSearch = React.useCallback((value) => {
    const handleRequestSearch = (value) => {
        console.log(value)
        localStorage.setItem('currentsearch', value);
        localStorage.removeItem('searchType');
        var iOSstr = encIOSURL(value);
        var encsearch = encodeURIComponent(iOSstr);
        var apiUrl = 'search?searchmode=tvpros-filter-search&searchtype=2&searchterm=' + encsearch;
        dispatch(switchMasterMode('search'));
        dispatch(switchApiPage(1));
        dispatch(switchApiUrl(apiUrl));
        dispatch(fetchApiData());
        navigate('/search');
        scrollToTop();
    }

    return (
        <Tooltip TransitionComponent={Fade} title={'Show all tracks from ' + props.artist_name} placement="right" arrow>
            <Button component="h6" color="primary" onClick={() => handleRequestSearch(props.artist_name)} variant="text">{props.artist_name} ({props.duration})</Button>
        </Tooltip>
    )
}

function mapStateToProps(state) {
    return {
        user: state.user,
        api: state.api,
    };
}



export default connect(mapStateToProps)(ArtistSearch)
